import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { Content, Page } from '@backstage/core-components';
import {
  HomePageRequestedReviewsCard,
  HomePageYourOpenPullRequestsCard,
} from '../github';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { UsefulLinks } from '../useful-links/UsefulLinks';

import { PersonalJiraOverviewCard } from '../jira';
import ScoreBoardCard from '../scoreboard/ScoreBoardCard';

export const HomePage = () => {
  const [githubAuthor, setGithubAuthor] = React.useState('');
  const [isGithubAuthor, setIsGithubAuthor] = React.useState(false);
  const identityApi = useApi(identityApiRef);
  identityApi.getBackstageIdentity().then(obj => {
    setGithubAuthor(obj.userEntityRef.replace('user:default/', ''));
    setIsGithubAuthor(true);
  });
  /* We will shortly compose a pretty homepage here. */
  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Content>
          <Grid container justifyContent="center" spacing={2}>
            <Grid container item xs={12} justifyContent="center">
              <Typography variant="h3" gutterBottom>
                Welcome to TowerBridge
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={6}>
                <PersonalJiraOverviewCard />
              </Grid>
              <Grid item xs={6}>
                <ScoreBoardCard />
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={6}>
                <HomePageRequestedReviewsCard />
              </Grid>
              <Grid item xs={6}>
                {/* You can build up a query using Github Advanced Search https://github.com/search/advanced */}
                {isGithubAuthor && (
                  <HomePageYourOpenPullRequestsCard
                    query={`org:VFG-VBPS-PPE is:pr state:open author:${githubAuthor}`}
                  />
                )}
              </Grid>
            </Grid>
            {/* Favorites Entities and Jira Metrics */}
            <Grid container item xs={12}>
              <Grid item xs={12}>
                <UsefulLinks />
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};
